import { render, staticRenderFns } from "./EquipmentAttachments.vue?vue&type=template&id=688323a1&"
import script from "./EquipmentAttachments.vue?vue&type=script&lang=js&"
export * from "./EquipmentAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports